import { gql } from "@apollo/client";

export const RELEASE_VERSION = gql`
  query getReleaseVersion {
    getReleaseVersion
  }
`;

export const STRING_TRANSLATIONS = gql`
  query stringTranslations($languageCode: String!) {
    stringTranslations(languageCode: $languageCode) {
      languageCode
      strings {
        countryCode
        key
        defaultValue
        value
      }
    }
  }
`;

export const TRANSLATIONS_FILE = gql`
  query translationsFile($languageCode: String!) {
    translationsFile(languageCode: $languageCode) {
      name
      content
    }
  }
`;
